// Maps the icon name strings stored in room amenity JSON (e.g. "BedDouble")
// to the actual lucide-react icon components, since JSON can't carry
// component references. Keep this list in sync with whatever icons admins
// are allowed to pick in the Rooms admin UI.
import {
  BedDouble,
  Sparkles,
  Blinds,
  Snowflake,
  Trees,
  Bath,
  Armchair,
  Wifi,
  Cable,
  DoorOpen,
  Lock,
  AlarmSmoke,
  Camera,
  Sun,
  Tv,
  Utensils,
  Refrigerator,
  ShowerHead,
  Fan,
  Shirt,
  KeyRound,
  ShieldCheck,
  type LucideIcon,
} from 'lucide-react';

export const AMENITY_ICON_MAP: Record<string, LucideIcon> = {
  BedDouble,
  Sparkles,
  Blinds,
  Snowflake,
  Trees,
  Bath,
  Armchair,
  Wifi,
  Cable,
  DoorOpen,
  Lock,
  AlarmSmoke,
  Camera,
  Sun,
  Tv,
  Utensils,
  Refrigerator,
  ShowerHead,
  Fan,
  Shirt,
  KeyRound,
  ShieldCheck,
};

export const AMENITY_ICON_NAMES = Object.keys(AMENITY_ICON_MAP);

export function resolveAmenityIcon(name: string): LucideIcon {
  return AMENITY_ICON_MAP[name] ?? Sparkles;
}
